import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import { OperacionesProvider } from '../../base/contexts/OperacionesContext.tsx'

const CocinaPantalla = lazy(() => import('./view/CocinaPantalla'))

export const cocinaRoutesMap = {
  pantalla: {
    path: '/cocina',
    name: 'Cocina',
    action: 'GESTION_DE_PEDIDOS',
  },
}

const cocinaRoutes = [
  {
    path: cocinaRoutesMap.pantalla.path,
    element: (
      <OperacionesProvider>
        <CocinaPantalla />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
]

export default cocinaRoutes
